var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CONFIG } from "@rentiohq/shared-frontend/dist/config/app.config";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { formatBytes } from "@rentiohq/shared-frontend/dist/utils/number.utils";
import { uniqBy } from "lodash";
import { useDropzone } from "react-dropzone";
import { ASSETS } from "../../assets";
import { enqueueSnackbar } from "../../utils/snackbar";
import { Menu } from "../Menu";
import { UploadFieldStyles } from "./UploadField.styles";
export var showDropErrors = function (params) {
    var fileRejections = params.fileRejections, _a = params.maxFileSize, maxFileSize = _a === void 0 ? CONFIG.UPLOAD_MAX_FILE_SIZE : _a, _b = params.minFileSize, minFileSize = _b === void 0 ? CONFIG.UPLOAD_MIN_FILE_SIZE : _b;
    fileRejections.forEach(function (_a) {
        var errors = _a.errors, file = _a.file;
        errors.forEach(function (error) {
            switch (error.code) {
                case "file-too-large":
                    enqueueSnackbar("".concat(file.name, ": ").concat(getLocalizedText("files.error.size_limit_exceeded", {
                        size: formatBytes(maxFileSize),
                    })), { variant: "error" });
                    break;
                case "file-too-small":
                    enqueueSnackbar("".concat(file.name, ": ").concat(getLocalizedText("files.error.size_too_small", {
                        size: formatBytes(minFileSize),
                    })), { variant: "error" });
                default:
                    break;
            }
        });
    });
};
export var UploadField = function (props) {
    var id = props.id, name = props.name, onChange = props.onChange, _a = props.asDropzone, asDropzone = _a === void 0 ? true : _a, _b = props.multiple, multiple = _b === void 0 ? false : _b, _c = props.disabled, disabled = _c === void 0 ? false : _c, _d = props.maxFileSize, maxFileSize = _d === void 0 ? CONFIG.UPLOAD_MAX_FILE_SIZE : _d, _e = props.minFileSize, minFileSize = _e === void 0 ? CONFIG.UPLOAD_MIN_FILE_SIZE : _e, accept = props.accept, required = props.required, error = props.error, formikProps = props.formikProps;
    var dropzoneProps = {
        onDrop: handleDrop,
        multiple: multiple,
        maxSize: maxFileSize,
        minSize: minFileSize,
        disabled: disabled,
        accept: accept,
    };
    var _f = useDropzone(dropzoneProps), getRootProps = _f.getRootProps, getInputProps = _f.getInputProps, isDragActive = _f.isDragActive;
    var sx = UploadFieldStyles({
        hasError: Boolean(error),
        isDraggingOver: isDragActive,
    });
    var selectedFiles = (formikProps === null || formikProps === void 0 ? void 0 : formikProps.values[id]) || [];
    function handleDrop(acceptedFiles, fileRejections, event) {
        showDropErrors({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            event: event,
            maxFileSize: maxFileSize,
            minFileSize: minFileSize,
        });
        if (acceptedFiles.length === 0) {
            return;
        }
        if (multiple) {
            var newFilesSet = uniqBy(__spreadArray(__spreadArray([], selectedFiles, true), acceptedFiles, true), "name");
            onChange(newFilesSet);
            return;
        }
        onChange(acceptedFiles);
    }
    function handleChange(_a) {
        var acceptedFiles = _a.target.files;
        if (multiple) {
            var newFilesSet = uniqBy(__spreadArray(__spreadArray([], selectedFiles, true), acceptedFiles, true), "name");
            onChange(newFilesSet);
            return;
        }
        onChange(acceptedFiles);
    }
    function handleRemoveFile(file) {
        onChange(selectedFiles.filter(function (selectedFile) { return selectedFile.name !== file.name; }));
    }
    // To accept all, just leave the 'accept' prop out.
    // if (accept && accept !== "*") dropzoneProps.accept = accept;
    if (asDropzone)
        return (_jsxs(_Fragment, { children: [selectedFiles
                    ? selectedFiles.map(function (file) { return (_jsxs(Stack, { justifyContent: "space-between", flexDirection: "row", alignItems: "center", mb: 2, children: [_jsxs(Stack, { children: [_jsx(Typography, { variant: "caption", sx: sx.content.fileName, children: file.name }), _jsx(Typography, { variant: "caption", sx: sx.content.fileSize, children: formatBytes(file.size) })] }), _jsx(Box, { children: _jsx(Menu, { actions: [
                                        {
                                            label: "system.remove",
                                            onClick: function () { return handleRemoveFile(file); },
                                        },
                                    ] }) })] }, file.name)); })
                    : null, _jsxs(Box, __assign({}, getRootProps(), { sx: sx.wrapper, children: [_jsx("input", __assign({ id: id, name: typeof name === "string" ? name : undefined, multiple: multiple }, getInputProps())), _jsxs(Stack, { direction: "row", gap: 2, alignItems: "center", children: [_jsx("img", { src: ASSETS.uploadFile, alt: "uploadFile" }), _jsxs(Stack, { direction: "column", gap: 1, children: [_jsx(Typography, { variant: "h5", sx: sx.content.placeHolderTitle, children: getLocalizedText("system.upload.label") }), _jsx(Typography, { variant: "subtitle2", children: isDragActive
                                                ? getLocalizedText("system.upload.drag_placeholder")
                                                : getLocalizedText("system.upload.select_placeholder") })] })] })] }))] }));
    return (_jsx("input", { id: id, name: typeof name === "string" ? name : undefined, required: required, type: "file", onChange: handleChange, defaultValue: "", multiple: multiple, accept: accept, disabled: disabled }));
};
